import { Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import type { DashboardInterview } from '@/api/dashboardApi';
import { SectionCard } from '@/components/common';
import { AppraisalStatusChip } from './AppraisalStatusChip';

function appraisalLabel(firstName: string, lastName: string): string {
  return `Appraisal \u2013 ${firstName} ${lastName}`;
}

interface MyPlannedInterviewsSubsectionProps {
  plannedInterviews: DashboardInterview[];
}

export function MyPlannedInterviewsSubsection({ plannedInterviews }: MyPlannedInterviewsSubsectionProps) {
  return (
    <SectionCard>
      <Typography component="h3" sx={{ typography: { xs: 'h6', md: 'h5' }, mb: 2 }}>
        My Planned Interviews
      </Typography>
      {plannedInterviews.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No planned interviews to display.
        </Typography>
      ) : (
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ bgcolor: 'custom.darkTeal', '& th': { color: 'common.white' } }}>
                <TableCell>INTERVIEWEE</TableCell>
                <TableCell>TENURE IN GRADE</TableCell>
                <TableCell>APPRAISEE</TableCell>
                <TableCell>STATUS</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {plannedInterviews.map((item) => (
                <TableRow key={item.interviewCandidateId}>
                  <TableCell>{item.intervieweeName}</TableCell>
                  <TableCell>{item.intervieweeTenureInGrade || '-'}</TableCell>
                  <TableCell>
                    <Link component={RouterLink} to={`/appraisals/${item.appraisalId}`} underline="hover">
                      {appraisalLabel(item.appraiseeFirstName, item.appraiseeLastName)}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <AppraisalStatusChip status={item.completed ? 'Completed' : 'Planned'} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </SectionCard>
  );
}

export default MyPlannedInterviewsSubsection;
